import { gql } from "@apollo/client";

export const UPDATE_STORE_DETAIL = gql`
  mutation($projectId: ID!, $storeDetail: StoreDetailInput!) {
    updateStoreDetail(projectId: $projectId, storeDetail: $storeDetail) {
      id
      projectId
      image
      name
      address
      subDistrict
      district
      city
      postcode
      phoneNumber
      facebookLink
      instagramLink
      twitterLink
      websiteLink
      offlineStore {
        id
        projectId
        name
        address
        phoneNumber
        location
        isActive
        openingHours {
          day
          open
          close
          isActive
        }
      }
    }
  }
`;
